module.exports = __webpack_public_path__ + "img/c00_buildingtechcoinage_Normal_ua.6cd5e28d.webp";